import React from "react";
import ErrorBoundary from './components/shared/ErrorBoundary';
import VendorResponsePage from './components/vendor/VendorResponsePage';
import AppInner from './AppInner';

export default function App() {
  const respondToken = new URLSearchParams(window.location.search).get('respond');
  if (respondToken) return <ErrorBoundary><VendorResponsePage token={respondToken} /></ErrorBoundary>;
  return <ErrorBoundary><AppInner /></ErrorBoundary>;
}
